<template>
  <section class="experience-map-section" :aria-label="ariaLabel">
    <div class="col-12">
      <h2 id="find" class="exp-mb-20">{{ headline_title }}</h2>
      <div class="col-md-8 offset-md-2 headline exp-mb-50" v-html="headline_text"></div>
      <div v-if="slug === 'birding' || 'year-of-trails'" class="hide-btn"></div>
      <div v-else>
        <b-btn v-if="slug == 'alabama-restaurant-week' ||
          '/my-trip/staying-safe/responsibly'
          " class="inactive-btn exp-mb-50" :to="`/places-to-go/map/experiences/${mapDestinationType}`">{{ btn_text ?
    btn_text : "View All" }}</b-btn>
        <b-btn v-else class="inactive-btn exp-mb-50" :to="`/places-to-go/map/experiences/${mapDestinationType}`">{{
          btn_text ? btn_text : "View All" }}</b-btn>
      </div>
    </div>
    <button v-if="this.$store.state.maps &&
      this.$store.state.maps.selectedTab !== 'trips' &&
      this.showSearchButton
      " class="search-button" @click="searchArea()">
      Search This Area
    </button>
    <div class="row no-gutters mobile-row">
      <div class="col-lg-6 col-10 experience-list" v-if="locations" v-bind:class="{ active: showMobileList }">
        <div v-on:click="showMobileList = !showMobileList" class="mobile-toggle">
          <img src="/images/parks/caret-left-solid.svg" class="caret-image" alt="" role="presentation" />
        </div>
        <div class="experience-list-details">
          <div @mouseenter="isMobile ? null : setHoveredLocation(location)" v-match-heights="{ el: ['.experience'] }"
            v-for="(location, index) in alphaLocations" :key="index" :class="[
              $store.state.maps.hoveredLocation &&
                $store.state.maps.hoveredLocation.id === location.id
                ? ''
                : '',
              index == alphaLocations.length - 1 ? 'last-item' : '',
            ]" class="container park">
            <hr class="spacer" v-if="index != 0" />
            <div class="row park-row" :data-id="location.id">
              <div class="park-info col-lg-4 col-7 align-self-center">
                <div class="small text-left experience-name">
                  <router-link class="full-experience-name" :to="`/places-to-go/${location.slug}`">{{ location.name
                  }}</router-link>
                  <router-link class="truncate-experience-name" :to="`/places-to-go/${location.slug}`">{{
                    location.name.length > 30
                    ? location.name.substr(0, 30) + '...'
                    : location.name
                  }}</router-link>
                </div>
                <div class="small text-left experience-type">
                  {{
                    location.type.length > 15
                    ? location.type
                      .substr(0, 15)
                      .replace(/([A-Z])/g, ' $1')
                      .trim() + '...'
                    : location.type.replace(/([A-Z])/g, ' $1').trim()
                  }}
                </div>
                <div class="address text-left">{{ location.address }}</div>
                <div class="address text-left">
                  {{ location.city }}, AL {{ location.zip }}
                </div>
              </div>
              <div class="county-map col-lg-1 pt-3 align-self-center mobile-pl mobile-map">
                <CountyMap v-if="location.counties" :Region="location.region" :ScaleX="1" :ScaleY="1"
                  :counties="location.counties.map((c) => c.toLowerCase())" :Rotate="-7" class="mobile-pl" />
              </div>
              <div class="experience-summary col-lg-5 d-flex align-items-center mobile-pl">
                <div class="text-left mobile-pl" v-if="location.summary.length < 100">
                  {{ location.summary }}
                </div>
                <div class="text-left mobile-pl" v-else>
                  {{ location.summary.substr(0, 100) }}...
                </div>
              </div>
              <div class="col-lg-2 col-5 text-right pt-2 pb-2">
                <div class="mr-2">
                  <template>
                    <div>
                      <UserFavorite parent="xp-list" :objectid="location.id" :index="index" :slug="location.slug"
                        class="user-favorite-component" />
                    </div>
                    <div class="view-more pt-4">
                      <router-link :to="`/places-to-go/${location.slug}`">View More</router-link>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <div v-if="locations.length == 0" class="no-results">
            <div>No results found.</div>
          </div>
          <div :class="pagingClass" class="col-lg-12 paging">
            <div class="row no-gutters">
              <div class="col-lg-9 col-8">
                <div class="text-left featured">
                  {{
                    results_title
                    ? results_title
                    : `Featured ${experienceTitle} Experiences`
                  }}
                </div>
                <div class="text-left page-info">
                  Viewing {{ resultSet }} of {{ totalLocationsCount }} Results
                </div>
              </div>
              <div class="col-lg-3 col-4 text-right paging-buttons">
                <span v-if="currentPage > 1" @click="prevPage()">
                  <IconBase variant="arrow-long-left" size="24" color="" classes="ml-2 list-buttons" />
                  </span>
                <span v-if="currentPage < totalPages" @click="nextPage()">
                  <IconBase variant="arrow-long-right" size="24" color="" classes="ml-2 list-buttons" />
                  </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-6 col-12 experience-map">
        <GmapMap
          id="map"
          ref="map"
          :center="this.$store.state.maps.centerPoint"
          :zoom="7"
          :options="{
            mapTypeControl: false,
            streetViewControl: false,
            rotateControl: false,
            fullscreenControl: false,
            disableDefaultUi: true,
            styles: styles,
          }"
          map-type-id="roadmap"
          @zoom_changed="showSearchAreaButton()"
          @dragend="showSearchAreaButton()"
        >
          <MapInfoWindow
            v-if="$store.state.maps.hoveredLocation"
            :location="$store.state.maps.hoveredLocation"
          />
          <google-map-cluster :grid-size="gridSize" :styles="clusterStyle" :zoomOnClick="true">
            <MapPin
              :key="pin.id"
              v-for="pin in locationsPagedPins"
              :location="pin"
              :show="pin.show"
            />
          </google-map-cluster>
        </GmapMap>
      </div>
    </div>
  </section>
</template>

<script>
import styles from '@/assets/map_styling.json';
import UserFavorite from '@/components/Common/UserFavorite.vue';
import MapInfoWindow from '@/components/Maps/MapInfoWindow.vue';
import MapPin from '@/components/Maps/MapPin.vue';
import CountyMap from '@/components/PlacesToGo/Common/CountyMap.vue';
import { Component, Vue, Watch } from 'vue-property-decorator';
import GoogleMapCluster from 'vue2-google-maps/dist/components/cluster';
import IconBase from '../../Common/icons/index.vue';

@Component({
  components: {
    MapPin,
    CountyMap,
    MapInfoWindow,
    UserFavorite,
    GoogleMapCluster,
    IconBase,
  },
  props: {
    arw: {
      type: Array,
    },
    locations: {
      type: Array,
    },
    headline_title: {
      type: String,
    },
    headline_text: {
      type: String,
    },
    results_title: {
      type: String,
    },
    ariaLabel: {
      type: String,
      required: true,
    },
    btn_text: {
      type: String,
    },
    experienceTitle: {
      type: String,
    },
    mapDestinationType: {
      type: String,
    },
    slug: {
      type: String,
    },
  },
  data() {
    return {
      styles,
      showSearchButton: false,
      locationPins: null,
      locationsPaged: null,
      alphaLocations: null,
      locationsPagedPins: null,
      perPage: 25,
      page: 1,
      pagingClass: 'paging-sticky',
      resultSet: null,
      currentPage: 1,
      mode: 'internal',
      heartHovered: false,
      locationHeartHovered: null,
      totalPages: null,
      showMobileList: false,
      userLocation: null,
      googleParks: null,
      map: null,
      totalLocationsCount: null,
      isMobile: false,
      reset: false,
      gridSize: 30,
      clusterStyle: [
        {
          url: 'https://alabama-travel-web.s3.amazonaws.com/images/makers/cluster_icon.svg',
          width: 46,
          height: 46,
          textColor: '#ffffff',
          textSize: 14,
        },
        {
          url: 'https://alabama-travel-web.s3.amazonaws.com/images/makers/cluster_icon.svg',
          width: 46,
          height: 46,
          textColor: '#ffffff',
          textSize: 14,
        },
        {
          url: 'https://alabama-travel-web.s3.amazonaws.com/images/makers/cluster_icon.svg',
          width: 46,
          height: 46,
          textColor: '#ffffff',
          textSize: 14,
        },
      ],
    };
  },
  created() {
    window.addEventListener('resize', this.mq);
    if (this.locations.length < 6) {
      this.pagingClass = 'paging-absolute';
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.mq);
  },
  methods: {
    mq() {
      this.isMobile = window.matchMedia('(max-width: 400px)').matches;
    },
    nextPage() {
      this.$store.dispatch('maps/setHoveredLocation', null);
      const existingPage = this.page;
      this.page++;
      this.currentPage = this.page;
      if (this.perPage * this.page > this.locations.length) {
        this.resultSet = `${this.perPage * existingPage} - ${this.locations.length}`;
      } else {
        this.resultSet = `${this.perPage * existingPage} - ${this.perPage * this.page}`;
      }
      this.locationsPaged = this.locations.slice(
        this.perPage * existingPage,
        this.perPage * this.page,
      );
      this.alphaLocations = this.locationsPaged.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      });
      this.locationsPagedPins = this.locationPins.slice(
        this.perPage * existingPage,
        this.perPage * this.page,
      );
      if (this.page === this.totalPages && this.locationsPaged.length < 6) {
        this.pagingClass = 'paging-absolute';
      }
    },
    prevPage() {
      this.$store.dispatch('maps/setHoveredLocation', null);
      this.page--;
      this.currentPage = this.page;
      if (this.page === 1) {
        this.resultSet = `1 - ${this.perPage * this.page}`;
        this.locationsPaged = this.locations.slice(0, this.perPage * this.page);
        this.alphaLocations = this.locationsPaged.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        this.locationsPagedPins = this.locationPins.slice(
          0,
          this.perPage * this.page,
        );
      } else {
        this.resultSet = `${this.perPage * (this.page - 1)} - ${this.perPage * this.page}`;
        this.locationsPaged = this.locations.slice(
          this.perPage * (this.page - 1),
          this.perPage * this.page,
        );
        this.alphaLocations = this.locationsPaged.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        this.locationsPagedPins = this.locationPins.slice(
          this.perPage * (this.page - 1),
          this.perPage * this.page,
        );
      }
      if (this.page !== this.totalPages && this.locationsPaged.length > 4) {
        this.pagingClass = 'paging-sticky';
      }
    },
    setHoveredLocation(location) {
      this.heartHovered = false;
      this.$store.dispatch('maps/setHoveredLocation', location);
    },
    setLocationHeartHovered(location) {
      this.heartHovered = true;
      this.locationHeartHovered = location.name;
    },
    resetLocationHeartHovered() {
      this.heartHovered = false;
      this.locationHeartHovered = null;
    },
    addToFavorites(location) {
      this.heartHovered = false;
      this.locationHeartHovered = null;
      location.isFavorited = true;
    },
    removeFavorite(location) {
      this.heartHovered = false;
      this.locationHeartHovered = null;
      location.isFavorited = false;
    },
  },
})
class ExperienceList extends Vue {
  @Watch('locations', { immediate: true, deep: false })
  locationsupdated() {
    if (this.locations) {
      this.$nextTick(() => {
        this.locationPins = this.locations.map((l) => ({
          id: l.id,
          position: {
            lat: parseFloat(l.latitude),
            lng: parseFloat(l.longitude),
          },
          type: l.type,
          name: l.name,
          address: l.address,
          city: l.city,
          zip: l.zip,
          slug: l.slug,
          show: true,
        }));
        this.totalPages = Math.ceil(this.locations.length / this.perPage);
        this.locationsPaged = this.locations.slice(0, 25);
        this.alphaLocations = this.locationsPaged.sort((a, b) => {
          if (a.name < b.name) {
            return -1;
          }
          if (a.name > b.name) {
            return 1;
          }
          return 0;
        });
        this.locationsPagedPins = this.locationPins.slice(0, 25);
        if (this.locations.length < 25) {
          this.resultSet = this.locations.length;
        } else {
          this.resultSet = '1-25';
        }
        this.totalLocationsCount = this.locations.length;
      });
    }
  }

  async showSearchAreaButton() {
    this.showSearchButton = true;
  }

  async searchArea() {
    this.showSearchButton = false;
    const map = this.$refs.map.$mapObject;
    const bounds = map.getBounds();
    // emit to parent to reload the map with new bounds
    this.$emit('reloadExperiencesMap', bounds);
    this.reset = true;
    this.currentPage = 1;
    this.page = this.currentPage;
  }

  async handleBoundsChanged() {
    if (this.$refs && this.$refs.map) {
      const map = this.$refs.map.$mapObject;
      const bounds = map.getBounds();

      if (bounds) {
        await this.$store.dispatch('maps/setLocationsBounds', bounds);
      }
    }
    this.$store.dispatch('maps/setLoading', true);
    // suppressed this call to stop the 5 second load of natural wonders content on every page.
    // problem is the selectedTab reported as wonders here despite page context.
    // this is a good place to start if trying to find where wonders is being set as a tab,
    // but for now hoping to just comment out call to updateLocations at this point in order to
    // suppress natural wonders content from always  showing. - CSD
    //  await this.$store.dispatch('maps/updateLocations');
    this.$store.dispatch('maps/setPanToLocations', true);
    this.showSearchButton = false;
  }

  async panToLocations() {
    this.$store.dispatch('maps/setPanToLocations', false);
    let minLatitude = 90;
    let minLongitude = 180;
    let maxLatitude = -90;
    let maxLongitude = -180;
    const margin = 0.2;

    const locationData = this.$store.state.maps.selections;

    if (locationData.length === 0) {
      return;
    }

    locationData.forEach((location) => {
      const latitude = location.position.lat;
      const longitude = location.position.lng;
      if (latitude < minLatitude) {
        minLatitude = latitude;
      }
      if (latitude > maxLatitude) {
        maxLatitude = latitude;
      }
      if (longitude < minLongitude) {
        minLongitude = longitude;
      }
      if (longitude > maxLongitude) {
        maxLongitude = longitude;
      }
    });

    if (this.$refs && this.$refs.map) {
      const map = this.$refs.map.$mapObject;
      const bounds = {
        south: minLatitude - margin,
        west: minLongitude - margin,
        north: maxLatitude + margin,
        east: maxLongitude + margin,
      };
      map.setZoom(20);
      map.fitBounds(bounds);
      this.$store.dispatch('maps/setLoading', false);
    }
  }
}

export default ExperienceList;
</script>

<style scoped>
/* Main Page Styles */
.experience-map {
  height: 821px;
}

/* Search Button Styles */
.search-button {
  background-color: #ffffff;
  z-index: 9999;
  position: absolute;
  right: 100px;
}

/* Park Styles */
.park {
  height: 12vh;
}

.park-row {
  margin-top: 0px;
  padding-bottom: 5px;
}

.park-row:hover {
  background-color: #f6f6f6;
}

/* Spacer Styles */
.spacer {
  margin-top: 3.5rem;
  margin-bottom: 0rem;
  width: 83vw;
  margin-left: -14px;
  z-index: -10;
}

/* No Results Message */
.no-results {
  color: red;
  display: block;
  padding: 260px;
  text-align: center;
  width: 100%;
}

/* WSA Dock */
.wsa-dock {
  visibility: hidden;
}

/* Search Button Styles */
button.search-button {
  border-color: #979797;
  border-style: solid;
  border-width: 1px;
  padding: 10px 25px 10px 25px;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  color: #173945;
  text-decoration: none;
  font-family: 'klinicslabbold';
  border-top: none;
}

/* Vue Map Container Styles */
.vue-map-container {
  position: unset !important;
  height: auto;
}

/* Container Styles */
.container {
  max-width: 100%;
}

/* G Map Styles */
.g-map {
  width: 100%;
}

/* Experience Styles */
.experience {
  border-bottom: solid #cccc 1px;
}

.experience:first-child {
  border-top: solid #cccc 1px;
}

.exp-mb-20 {
  margin-bottom: 20px;
}

.exp-mb-50 {
  margin-bottom: 50px;
}

.experience:hover {
  border-left: solid 15px #4e97b2;
  background-color: rgba(225, 225, 225, 0.1);
}

/* Paging Styles */
.paging {
  background-color: #173945;
  padding: 10px 10px 20px 35px;
  z-index: 9999999;
}

.paging-sticky {
  bottom: 0 !important;
  position: sticky;
}

.paging-absolute {
  bottom: 0 !important;
  position: absolute;
}

.featured {
  color: white;
  font-weight: 700;
  padding-top: 10px;
  line-height: 18px;
}

.page-info {
  color: white;
  font-size: 16px;
  z-index: 9999;
}

.paging-buttons {
  fill: #ffffff;
  padding-right: 20px;
  padding-top: 8px;
}

.list-buttons {
  display: inline-block;
}

.list-buttons:hover {
  cursor: pointer;
}

.paging-buttons span:hover {
  fill: orange;
}

/* Experience Details Styles */
.experience-summary {
  font-size: 12px;
}

.address {
  font-size: 14px;
  color: #173945 !important;
  font-family: 'klinicslabmedium';
  line-height: 16px;
}

.experience-name {
  color: #173945 !important;
  font-size: 16px;
  font-weight: 700;
  text-decoration: underline;
  font-family: 'klinicslabbold';
  line-height: 17px;
}

.experience-type {
  font-family: 'klinicslablight';
  font-size: 14px;
  line-height: 16px;
}

/* Button Styles */
.active-btn {
  background-color: #173945;
}

.inactive-btn {
  background-color: #ffffff;
  color: #173945;
}

.hide-btn {
  display: none !important;
}

/* View More Link Styles */
div.view-more a {
  color: #173945 !important;
  font-size: 14px;
  font-family: 'klinicslabbold';
}

/* Heart Icon Styles */
.heart {
  color: #d86f48;
  z-index: 2;
  display: none;
}

/* Save and Remove Favorite Styles */
.save-favorite,
.remove-favorite {
  font-size: 12px;
  border: 1px solid #173945;
  border-radius: 15px;
  padding: 5px 30px 5px 5px;
  position: absolute;
  top: 4px;
  right: 15px;
  z-index: 1;
  width: 150px;
  cursor: pointer;
  background: linear-gradient(to right,
      rgba(255, 255, 255, 1) 0%,
      rgba(255, 255, 255, 1) 52%,
      rgba(255, 255, 255, 0.33) 54%,
      rgba(255, 255, 255, 0) 55%,
      rgba(255, 255, 255, 0) 100%);
  /* Gradient for various browsers */
}

/* Experience List Styles */
.experience-list {
  background-color: #ffffff;
  border-right: solid 1px #173945;
}

/* Experience Info Styles */
.experience-info {
  font-size: 16px;
}

/* Mobile Toggle Styles */
.mobile-toggle {
  display: none;
}

/* Experience List Details Styles */
.experience-list-details {
  overflow: scroll;
  height: 821px;
}

/* Media Queries for Responsive Design */
@media only screen and (max-width: 991px) {

  /* Mobile Toggle Display */
  .mobile-toggle {
    display: block;
  }

  /* Mobile Layout Adjustments */
  .mobile-pl {
    display: none !important;
  }

  .mobile-row {
    position: relative;
  }

  .no-results {
    padding: 130px;
  }

  /* Active and Inactive Park Styles */
  .active-park {
    border-left: none;
    background-color: rgba(225, 225, 225, 0.1);
    display: none;
  }

  .inactive-park {
    border-left: none;
  }

  /* Mobile Map Container Height */
  .vue-map-container {
    height: 100vh;
  }

  /* Mobile Experience List */
  .experience-list {
    position: absolute;
    top: 35px;
    left: 0;
    z-index: 999;
    background-color: #ffffff;
    border-radius: 0px 8px 0px 0px;
    margin: 0px;
    padding: 0px;
    border-top: solid 1px #173945;
    box-shadow: 5px 5px 5px 0px rgba(0, 0, 0, 0.17);
    transition: left 0.3s ease-in-out;
  }

  /* Mobile Toggle Button */
  .mobile-toggle {
    background-color: #173945;
    position: absolute;
    right: -31px;
    top: 20px;
    width: 30px;
    padding: 20px 10px;
    border-radius: 0px 8px 8px 0px;
  }

  .mobile-toggle .caret-image {
    width: 7px;
    transform: rotate(0deg);
    transition: 0.3s ease-in-out;
  }

  .experience-list.active>.mobile-toggle>.caret-image {
    transform: rotate(180deg);
  }

  /* Paging Styles for Mobile */
  .paging {
    background-color: #173945;
    padding: 10px 20px 50px 20px;
  }

  .paging-buttons {
    padding-right: 10px;
    padding-top: 8px;
  }

  .view-more.pt-4 {
    padding-top: 20px !important;
  }
}

/* Additional Media Queries for Responsive Design */
@media (max-width: 991px) {
  .experience-list.active {
    left: -83.5vw;
    box-shadow: none;
  }
}

@media (max-width: 930px) {
  .experience-list.active {
    left: -83vw;
    box-shadow: none;
  }
}

@media (max-width: 896px) {
  .experience-list.active {
    left: -83.25vw;
    box-shadow: none;
  }
}

@media (max-width: 844px) {
  .experience-list.active {
    left: -83.25vw;
    box-shadow: none;
  }
}

@media (max-width: 820px) {
  .experience-list.active {
    left: -84vw;
    box-shadow: none;
  }
}

@media (max-width: 768px) {
  .experience-list.active {
    left: -84vw;
    box-shadow: none;
  }
}

@media (max-width: 667px) {
  .experience-list.active {
    left: -83.25vw;
    box-shadow: none;
  }
}

@media (max-width: 414px) {
  .experience-list.active {
    left: -83.5vw;
    box-shadow: none;
  }
}

@media (max-width: 375px) {
  .experience-list.active {
    left: -83.5vw;
    box-shadow: none;
  }
}

/* Landscape Mode Media Queries */
@media (min-device-width: 768px) and (max-device-width: 1024px) and (orientation: landscape) {
  .mobile-map {
    display: none;
  }

  .vue-map-container {
    height: 100vh;
  }
}

@media (min-device-width: 845px) and (orientation: landscape) {
  .vue-map-container {
    height: 146vh;
  }

  .experience-list.active {
    left: -83.5vw;
  }
}

@media (min-device-width: 847px) and (orientation: landscape) {
  .vue-map-container {
    height: auto;
  }
}

@media (min-device-width: 1024px) and (max-device-width: 1366px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
  .vue-map-container {
    height: 73vh;
  }
}

/* User Favorite Component Styles */
.user-favorite-component {
  margin-left: 2.5vw;
  position: relative;
  top: 0px;
  left: 0;
}

.view-more {
  padding-top: 1.5rem !important;
}

/* Media Queries for Screen Width */
@media (min-width: 1225px) {
  .user-favorite-component {
    margin-left: 1.5vw;
    top: 15px;
  }

  .view-more {
    width: 6vw;
    padding-top: 2rem !important;
  }

  .park {
    height: 7.5vh;
  }

  .park-row {
    margin-top: 0;
    padding-bottom: 5px;
  }

  .spacer {
    margin-top: 3.5rem;
    width: 50vw;
    margin-left: -17px;
  }
}

@media (max-width: 1224px) {
  .user-favorite-component {
    margin-left: 0.5vw;
  }

  .view-more {
    width: 6vw;
    padding-top: 1rem !important;
  }

  .park {
    height: 5.5vh;
  }

  .park-row {
    margin-top: 0;
    padding-bottom: 2px;
  }

  .spacer {
    margin-top: 3.5rem;
    width: 50vw;
    margin-left: -17px;
  }
}

@media (max-width: 1064px) {
  .user-favorite-component {
    margin-left: 0.5vw;
  }

  .view-more {
    width: 6.5vw;
    padding-top: 1rem !important;
  }

  .park {
    height: 5.5vh;
  }

  .park-row {
    margin-top: 0;
    padding-bottom: 5px;
  }

  .spacer {
    margin-top: 3.5rem;
    width: 50vw;
    margin-left: -17px;
  }
}

@media (max-width: 1024px) {
  .user-favorite-component {
    margin-left: 0vw;
  }

  .view-more {
    width: 6.5vw;
    padding-top: 1rem !important;
  }

  .spacer {
    margin-top: 3.5rem;
    width: 50vw;
    margin-left: -17px;
  }
}

@media (max-width: 992px) {
  .user-favorite-component {
    margin-left: 19.5vw;
  }

  .view-more {
    width: 29.5vw;
  }

  .park {
    height: 6vh;
  }

  .park-row {
    margin-top: 0;
    padding-bottom: 5px;
  }

  .spacer {
    margin-top: 3.5rem;
    width: 83vw;
    margin-left: -15px;
    z-index: -10;
  }
}

@media (max-width: 844px) {
  .user-favorite-component {
    margin-left: 19.5vw;
  }
}

@media (max-width: 768px) {
  .user-favorite-component {
    margin-left: 18.5vw;
  }
}

@media (max-width: 700px) {
  .user-favorite-component {
    margin-left: 18.5vw;
    top: 5px;
  }
}

@media (max-width: 600px) {
  .user-favorite-component {
    margin-left: 18.5vw;
  }
}

@media (max-width: 414px) {
  .user-favorite-component {
    margin-left: 8vw;
    top: 0px;
  }

  .view-more {
    width: 21vw;
  }
}

@media (max-width: 375px) {
  .user-favorite-component {
    margin-left: 5vw;
    top: 10px;
  }
}

/* Truncate and Full Experience Name Styles */
.truncate-experience-name {
  display: none;
}

.full-experience-name {
  display: block;
}

@media only screen and (min-width: 991px) and (max-width: 1425px) {
  .truncate-experience-name {
    display: block;
  }

  .full-experience-name {
    display: none;
  }
}

/* Anchor Link Styles */
a {
  color: #173945;
}

/* Last Item Margin */
.last-item {
  margin-bottom: 50px;
}
</style>
